import debug from "debug"
// To enable logging in browser: `localStorage.debug = "va"`
export default debug("va")
